module.exports = __webpack_public_path__ + "static/media/border.fab4ac9d.svg";